import { error, finish } from '../../../modules/system-settings/actions/get-widget-settings';
import api from '../../../api';
import { Amount } from 'src_common/common/amount/Amount';

function createValue(value) {
    console.log('betting configs create value new from anything');
    if (value === null) {
        return null;
    }
    if (value === undefined) {
        return undefined;
    }
    return $appState.configState.precision.newFromAnything(value).value;
}

export function request(dispatch) {
    api.get('/liabilities-alerts/settings', void 0, { cache: true }).then(
        data => {
            data = {
                ...data,
                multiples_payout_above_1: createValue(data.multiples_payout_above_1),
                multiples_payout_above_2: createValue(data.multiples_payout_above_2),
                multiples_payout_above_3: createValue(data.multiples_payout_above_3),
                lastlegrum_payout_above: createValue(data.lastlegrum_payout_above),
                lastlegrum_limit_resultset: createValue(data.lastlegrum_limit_resultset),
                avgnetpo_payout_above: createValue(data.avgnetpo_payout_above),
                avgnetpo_stakes_above: createValue(data.avgnetpo_stakes_above),
                avgnetpo_net_payout_below: createValue(data.avgnetpo_net_payout_below),
                avgnetpo_limit_resultset: createValue(data.avgnetpo_limit_resultset),
                liablimit_limit_resultset: createValue(data.liablimit_limit_resultset)

            };

            return dispatch(finish(data));
        },
        (errors) => dispatch(error(errors))
    );
}
